export type Template = {
    payment: boolean;
    realEstate: boolean;
    rental: boolean;
    inventory: boolean;
};
